// src/pages/SignIn.js
import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

import Typography from "../components/Typography";
import { useTheme } from "../context/ThemeContext";
import { spacing, borderRadius } from "../utils/tokens";

import Logo from "../assets/wsj x ideo.svg";
import ShinyText from '../components/ShinyText';

function SignIn() {
  const { theme } = useTheme();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { signIn } = useAuth();
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signIn(email, password);
      navigate("/"); // or your secure page
    } catch (err) {
      setError(err.message);
    }
  };

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      background: theme.colors.contentPrimary,
      text: theme.colors.fillPrimary,
      height: "100%",
      width: "100%",
      gap: spacing.xl,
    },
    form: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: spacing.l,
    },
    inputContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: spacing.s,
    },
    inputLabel: {
      color: theme.colors.fillPrimary,
    },
    inputField: {
      padding: `${spacing.s}px ${spacing.m}px`,
      background: theme.colors.fillSecondary,
      borderRadius: borderRadius.s,
      border: `1px solid ${theme.colors.fillPrimary}`,
    },
    buttonContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: `${spacing.m}px ${spacing.m}px`,
    },
    button: {
      padding: `${spacing.s}px ${spacing.m}px`,
      background: isHovered ? `rgba(255, 255, 255, 0.1)`: theme.colors.contentPrimary,
      color: theme.colors.contentPrimary,
      border: `1px solid rgba(255, 255, 255, 0.4)`,
      borderRadius: borderRadius.xl,
      cursor: "pointer",
      transition: "background 0.3s ease-in-out",
    }
  }

  return (
    <div style={styles.container}>

      <img style={{ width: "80%" }} src={Logo} alt="Logo" />

      {error && <p style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.inputContainer}>
          <label style={styles.inputLabel}>
            <Typography variant="label" type="utility">Email</Typography>
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.inputField}
          />
        </div>
        <div style={styles.inputContainer}>
          <label style={styles.inputLabel}>
            <Typography variant="label" type="utility">Password</Typography>
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.inputField}
          />
        </div>
        <div style={styles.buttonContainer} >
          <button style={styles.button} type="submit" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <ShinyText text="Enter the Experience" disabled={false} speed={3} className='custom-class' />
          </button>
        </div>
        
      </form>
    </div>
  );
}

export default SignIn;